import trim from 'lodash/trim'
import snakeCase from 'lodash/snakeCase'
import capitalize from 'lodash/capitalize'

export function humanize(str) {
  return capitalize(trim(snakeCase(str).replace(/_id$/, '').replace(/_/g, ' ')))
}
